import { useState, useEffect } from 'react';
import {toastError} from "../utils/toast"

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}

export const debounce = (func, delay, setLoading) => {
  let timer;
  return function (...args) {
    setLoading(true);
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), delay);
  };
};

export const verifyImageResolution = async(file, acceptWidth=1280, acceptHeight=720) =>{
  return new Promise((resolve, reject) => {
  const image = new Image();
  image.src = URL.createObjectURL(file);

  image.onload = async() => {
    const { width, height } = image;
    if ((width <=(acceptWidth+10) && width >= (acceptWidth-10)) && ( height <= (acceptHeight+10) || height >= (acceptHeight-10) )) {
        console.log("File Resolution");
        URL.revokeObjectURL(image.src);
        resolve(true);
      } else {
        toastError(`Incorrect resolution. Expected ${acceptWidth}x${acceptHeight}`);
        console.error("Incorrect resolution. Expected 1280x720, but got:", width, height);
        URL.revokeObjectURL(image.src);
         resolve(false);
    }
  }
  image.onerror = () => {
    toastError("Error in file upload");
      URL.revokeObjectURL(image.src);
       resolve(false);
    };
 });
}